module.exports = __webpack_public_path__ + "static/media/bereavement.699693d9.svg";